export default {
    url: '/edit/:id',
    template: '<forms-settings-questioncategories-edit question-category="vm.questionCategory"></forms-settings-questioncategories-edit>',
    resolve: {
        questionCategory: (QuestionCategoryResource, $stateParams) => QuestionCategoryResource.get({ id: $stateParams.id, expand: 'activeI18n,categoryI18ns' }).$promise
    },
    controller (questionCategory) {
        this.questionCategory = questionCategory;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/forms/settings/questioncategories/edit/index.js